import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormComponentsModule } from '@synx/form-components';
import { TableModule } from '@synx/table';
import { CoreModule } from '../../core/core.module';
import { CustomerFormModalComponent } from '../../customer-form-modal/customer-form-modal.component';
import { CustomerManagementPageComponent } from '../../customer-management-page/customer-management-page.component';
import { DeviceFormModalComponent } from '../../device-form-modal/device-form-modal.component';
import { DeviceManagementPageComponent } from '../../device-management-page/device-management-page.component';
import { HelpModalComponent } from '../../help-modal/help-modal.component';
import { CustomerManagementService } from '../../services/customer-management/customer-management.service';
import { HomeComponent } from '../home/home.component';
import { DeviceManagementService } from 'src/app/services/device-management/device-management.service';
import { LookupFormModalComponent } from 'src/app/lookup-form-modal/lookup-form-modal.component';
import { LookupFormComponent } from 'src/app/lookup-form/lookup-form.component';
import { BulkEditDeviceModalComponent } from 'src/app/bulk-edit-device-modal/bulk-edit-device-modal.component';
import { CustomerWrapperComponent } from 'src/app/customer-wrapper/customer-wrapper.component';
import { IoTToolPageComponent } from '../../iot-tool-page/iot-tool-page.component';
@NgModule({
  declarations: [
    CustomerManagementPageComponent,
    CustomerFormModalComponent,
    DeviceManagementPageComponent,
    DeviceFormModalComponent,
    LookupFormModalComponent,
    BulkEditDeviceModalComponent,
    HelpModalComponent,
    HomeComponent,
    LookupFormComponent,
    CustomerWrapperComponent,
    IoTToolPageComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HomeRoutingModule,
    NgbModule,
    FormComponentsModule,
    TableModule,

    // App Modules
    CoreModule,
    FormsModule
  ],
  exports: [CustomerWrapperComponent],
  providers: [DeviceManagementService],
  bootstrap: [HomeComponent],
})
export class HomeModule {}
